import { useEffect } from "react";
import HeroSection from "../components/HeroSection";
import About from "./About";
import Features from "../components/Features";
import Products from "./Products";
import StatsSection from "../components/StatsSection";
import Testimonials from "../components/Testimonials";
import Certifications from "./Certifications";

const Homepage = () => {

    useEffect(() => {
          document.title = "Deww Botanicals";
        }, []);

  return (
    <>
    <div className="homepage-wrapper">
      <HeroSection />
      <About />
      <Features />
      <Products />
      <Testimonials />
      <Certifications />
      <StatsSection />
      {/* <Blog /> */}
    </div>
    </>
  );
};

export default Homepage;
